module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-2_SE-7e719add56f5d621b75d9738ccc3ea7c.svg";